import { ClassAttributes, createElement, lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';

const UserSettingGeneralPage = lazy(() => import('../connected/UserSettingGeneralPageConnected'));
const UserSettingLoginPage = lazy(() => import('../connected/UserSettingLoginPageConnected'));
const UserSettingPaymentPage = lazy(() => import('../connected/UserSettingPaymentPageConnected'));
const UserSettingPersonalPage = lazy(() => import('../connected/UserSettingPersonalPageConnected'));
const AgentSettingMembersPage = lazy(() => import('../connected/AgentSettingMembersPageConnected'));
const AgentSettingPaymentsPage = lazy(() => import('../connected/AgentSettingPaymentPageConnected'));
const AccountSettingNewPage = lazy(() => import('../connected/AccountSettingNewPageConnected'));
const OrganizationAndAccount = lazy(() => import('../connected/SignedInScreenOrganizationAndAccountConnected'));
const QuestionnairePage = lazy(() => import('../connected/QuestionnairePageConnected'));
const IframeKaizenMarketPage = lazy(() => import('../connected/IframeKaizenMarketPageConnected'));
const SignUpViaInvitationAgentPage = lazy(() => import('../connected/SignUpViaInvitationAgentPageConnected'));
const HomePage = lazy(() => import('../connected/HomePage'));

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SignedInScreen = ({ className }: Props) => (
  <div className={className}>
    <Suspense fallback={<div />}>
      <Switch>
        {/* <Route exact sensitive path="/users/:userId" component={WorksListPage} /> */}
        {/* <Route exact sensitive path="/users/:userId/works/:workId" component={WorksListPage} /> */}
        <Route exact sensitive path="/user_setting/general" component={UserSettingGeneralPage} />
        <Route exact sensitive path="/user_setting/login" component={UserSettingLoginPage} />
        <Route exact sensitive path="/user_setting/personal" component={UserSettingPersonalPage} />
        <Route exact sensitive path="/user_setting/payment" component={UserSettingPaymentPage} />
        <Route exact sensitive path="/agent_setting/members" component={AgentSettingMembersPage} />
        <Route exact sensitive path="/agent_setting/payments" component={AgentSettingPaymentsPage} />
        {<Route exact sensitive path="/account_setting/new" component={AccountSettingNewPage} />}
        <Route
          sensitive
          path={['/organization_setting/:organizationId', '/account_setting/:organizationId']}
          component={OrganizationAndAccount}
        />
        <Route exact sensitive path="/questionnaire/:domain" component={QuestionnairePage} />
        <Route exact sensitive path="/organizations/:organizationId/:page" component={IframeKaizenMarketPage} />
        <Route exact sensitive path="/invitation_agent/:token" component={SignUpViaInvitationAgentPage} />
        <Route exact sensitive path="/home" component={HomePage} />
        <Redirect to="/home" />
      </Switch>
    </Suspense>
  </div>
);

export default SignedInScreen;
